import React from 'react';
import { PropTypes } from 'prop-types';
import { Link } from 'react-router-dom';
import ActivityPerms from 'components/AccessControl/permissions.json';
import AccessControl from 'components/AccessControl';

const buildAccountText = (accountNumber, accountName) => {
  if (accountName && accountNumber) {
    return `${ accountNumber } - ${ accountName }`;
  }
  if (accountNumber) {
    return accountNumber;
  }
  if (accountName) {
    return accountName;
  }
  return 'N/A';
};

// eslint-disable-next-line import/prefer-default-export
export const AccountLinkCellRenderer = ({
  data: form,
  context
}) => {
  const { permissions } = context;
  const link = form && `/account/${ form.accountId }`;
  const defaultDisplayData = buildAccountText(form.accountNumber, form.accountName);
  return (
    <div className="form-action-btn-group">
      { form && form.accountId > 0 && AccessControl.hasPermission(permissions, [ActivityPerms.accountEdit, ActivityPerms.accountPageView]) && <span className="text-ellipsis">
        <Link to={ link } className="text-bold" title={ defaultDisplayData }>{ defaultDisplayData }</Link>
      </span> }
      { form.customerDbId > 0 && !AccessControl.hasPermission(permissions, [ActivityPerms.accountEdit, ActivityPerms.accountPageView]) && <span className="text-ellipsis">
        <span className="text-bold" title={ defaultDisplayData }>{ defaultDisplayData }</span>
      </span> }
      { (!form || !form.accountId) && <span>N/A</span> }
    </div>
  );
};

AccountLinkCellRenderer.propTypes = {
  data: PropTypes.shape(),
  context: PropTypes.shape({
    permissions: PropTypes.arrayOf(PropTypes.string)
  })
};

AccountLinkCellRenderer.defaultProps = {
  context: {},
  data: {}
};
